import { render } from "./MatchErrorRow.vue?vue&type=template&id=4f197437&scoped=true&ts=true&lang=pug"
import script from "./MatchErrorRow.vue?vue&type=script&lang=ts"
export * from "./MatchErrorRow.vue?vue&type=script&lang=ts"

import "./MatchErrorRow.vue?vue&type=style&index=0&id=4f197437&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f197437"]])

export default __exports__